import { atom } from 'jotai';

export const draggableAtom = atom(false);